
import { z } from "zod";

export const ContractPartyValues = ["PARTNER", "REMI"] as const;
export const ContractPartySchema = z.enum(ContractPartyValues);
export const ContractParty = ContractPartySchema.enum;
export type ContractParty = (typeof ContractPartyValues)[number];
export const ContractPartyDisplayNames = { "PARTNER": "Partner",
"REMI": "Remi", } satisfies Record<ContractParty, string>;
